import { useEffect } from 'react';
import * as Onboarding from './Onboarding';

const firedForSession = new Set();

function StepAbandonmentTracker({ step, completedRef }) {
  useEffect(() => {
    const fire = reason => {
      if (completedRef && completedRef.current) return;
      const key = `${step}:${reason}`;
      if (firedForSession.has(key)) return;
      firedForSession.add(key);
      Onboarding.logAbandonedStep(step, { reason });
    };

    const onPagehide = () => fire('pagehide');
    const onBeforeunload = () => fire('beforeunload');
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') fire('hidden');
    };

    window.addEventListener('pagehide', onPagehide);
    window.addEventListener('beforeunload', onBeforeunload);
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.removeEventListener('pagehide', onPagehide);
      window.removeEventListener('beforeunload', onBeforeunload);
      document.removeEventListener('visibilitychange', onVisibility);
      fire('unmount');
    };
  }, [step, completedRef]);

  return null;
}

export default StepAbandonmentTracker;
